module.exports = __webpack_public_path__ + "img/trendingIcon.f4f2f373.svg";